import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getViewStockAdjustmentItems = createAsyncThunk(
    "/prosafe/getViewStockAdjustmentItems",
    async ({ formData }) => {
        try {
            const myurl = `${V_URL}/prosafe/pro-one-stock-adjustment`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to fetch stock adjustment details");
            }
        } catch (error) {
            const errMsg = error.response?.data?.message || error.message || "Failed to fetch stock adjustment details";
            toast.error(errMsg);
            throw error;
        }
    }
);

const getViewStockAdjustmentItemsSlice = createSlice({
    name: "getViewStockAdjustmentItems",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getViewStockAdjustmentItems.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getViewStockAdjustmentItems.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getViewStockAdjustmentItems.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getViewStockAdjustmentItemsSlice.reducer;
